import { PolymerElement } from '@polymer/polymer/polymer-element.js';
import template from './my-site-localization.html';
import { MySiteApp } from '../../my-site-app';
import { nuskin } from '@nuskin/ns-util'

class MySiteLocalization extends PolymerElement {
    static get template() {
        let htmlElement = document.createElement('TEMPLATE');
        htmlElement.innerHTML = template;
        return htmlElement;
    }

    static get is() {
        return 'my-site-localization';
    }

    connectedCallback() {
        super.connectedCallback();
        this.mySite = document.querySelector(MySiteApp.is);
        // this.$.selector.addEventListener('nsDropdownSelect', this._handleSelectedChange.bind(this));
        this.mySite.addEventListener('my-site-data-changed', this._handleMySiteDataChange.bind(this));
        this.mySite.addEventListener('current-market-changed', this._handleMarketChange.bind(this));
        this.mySite.addEventListener('current-language-changed', this._handleLangChange.bind(this));
        this.$.languageList.addEventListener('rendered-item-count-changed', () => {
            this.set('selected', -1);
            let index = this.mySite.marketsAndLanguages[this.mySite.currentMarket].languages.findIndex(item => item.code === this.mySite.currentLanguage);
            this.set('selected', index);
        });
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        // this.$.selector.removeEventListener('nsDropdownSelect', this._handleSelectedChange.bind(this));
        this.mySite.removeEventListener('my-site-data-changed', this._handleMySiteDataChange.bind(this));
        this.mySite.removeEventListener('current-market-changed', this._handleMarketChange.bind(this));
        this.mySite.removeEventListener('current-language-changed', this._handleLangChange.bind(this));
    }

    static get properties() {
        return {
            label: {
                type: String
            },
            selectedLanguage: {
                type: String,
                observer: '_handleSelectedLanguageChange'
            }
        };
    }

    selectLanguage(e) {
        this.mySite.currentLanguage = e.currentTarget.dataset.value;
    
        this.$.selector.shadowRoot.querySelector('#selectedItem').innerHTML  = e.currentTarget.innerHTML;
        // GA
        try {
            if(this.postInit)
                nuskin.events.publish(nuskin.events.mySite.SITE_LOCALIZATION, {
                    mySite: {
                        form: this.mySite.currentForm,
                        currentMarket: this.mySite.currentMarket,
                        languageSwithingTo: this.mySite.currentLanguage
                    }
                });
        } catch(err) {console.log(err)}
    }

    processSelect(e) {
        this.$.selector.shadowRoot.querySelector('#selectedItem').innerHTML = e.detail.item.innerHTML;
    }

    _handleMySiteDataChange(e) {
        this.mySiteData = e.detail.value;
        this.subdomain = Object.keys(this.mySiteData.storefront)[0];
        if(this.currentMarket != this.mySite.currentMarket)
            this.assignDatesToLanguages();
        this.currentMarket = this.mySite.currentMarket;
    }

    _handleMarketChange(e) {
        let market = e.detail.value;
        let languages = this.mySite.marketsAndLanguages[market].languages;
        this.set('languages', languages);
        this.assignDatesToLanguages();
    }

    _handleSelectedLanguageChange(newVal) {
        if(!newVal || !this.mySite || !this.mySite.marketsAndLanguages || this.mySite.currentMarket) return;
        let index = this.mySite.marketsAndLanguages[this.mySite.currentMarket].languages.findIndex(item => item.code === newVal);
        this.set('selectedIndex', index);
    }

    _handleLangChange(e) {
        let lang = e.detail.value;
        let language = this.assignDatesToLanguages(lang);

        if(!language) return
        this.$.selector.shadowRoot.querySelector('#selectedItem').innerHTML = `
    <section style="width: 100%">
    <style>
      .flex-row {
        font-family: var(--font-family-primary);
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-content: center;
        width: 100%;
        font-weight: 300;
        font-size: 14px;
      }

      span {
        color: var(--pencil);
        font-family: var(--font-family-primary);
        font-size: 9px;
        line-height: 9px;
        align-self: center;
      }
    </style>
    <div class="flex-row">
      ${language.displayName}
      <span>${language.lastEdited || ''}</span>
    </div>
  </section>`
    }

    assignDatesToLanguages(langCode) {
        if(this.mySiteData) {
            let languages = this.mySite.marketsAndLanguages[this.mySite.currentMarket].languages.map(lang => {
                let marketNode = this.mySiteData.storefront[this.subdomain][this.mySite.currentMarket];
                if(!marketNode) return;
                let langNode = marketNode.lang;
                let lastEdited = langNode[lang.code] ? langNode[lang.code].lastEdited : null;
                if(lastEdited) {
                    let date = new Date(lastEdited);
                    let formattedDate = date.toLocaleDateString(`${this.mySite.currentLanguage}-${this.mySite.currentMarket}`);
                    lang.lastEdited = this.mySite.content.aboutYourStoreFormLastEdited ? this.mySite.content.aboutYourStoreFormLastEdited.replace('{date}', formattedDate) : '';
                }
                return lang;
            });
            // this triggers another index select 
            // languages = languages.sort((a,b) => {
            //   if(a.lastEdited)
            //     return -1;
            //   if(b.lastEdited)
            //     return 1;
            // });

            if(langCode) return languages.find(item => item.code === langCode);

            this.set('formattedLanguages', []);
            setTimeout(()=>{
                this.set('formattedLanguages', languages);
            },100)

            let index = this.mySite.marketsAndLanguages[this.mySite.currentMarket].languages.findIndex(item => item.code === this.mySite.currentLanguage);

            this.set('selectedIndex', -1);
            this.set('selectedIndex', index);
        }
    }

}

window.customElements.define(MySiteLocalization.is, MySiteLocalization);